import { useSelect } from "@mui/base";
import { useSelector, useDispatch } from "react-redux";
import {
  addStaffInfo,
  addStaffEducationInformation,
  addStaffEmploymentInformation,
  addStaffCertificationInformation,
  addStaffAchievmentsInformation,
  addStaffInterestInformation,
  uploadProfilePic,
  addEducation,
  removeEducation,
  addEmployment,
  addCertification,
  addAchievement,
  removeEmployment,
  removeCertification,
  getStaffInfo,
  removeAchivement,
  searchStaffAction,
  setActiveStaff,
  updateStaff,
  deleteFacultyInfo,
  deleteFacultyEducation,
  deleteFacultyEmployment,
  deleteFacultyCertification,
  deleteFacultyAchievements,
  facultySearch,
  setStaffProfileCompleteness,
  getStaffAttendance,
  updateEductionInfoItemData,
  updateEmploymentInfoItemData,
  updateCertificationInfoItemData,
  updateAchivementsInfoItemData,
  resetProfileCompleteness,
  resetPersonalInfo,
  resetStaffPersonalInfo,
  resetStaffAttendanceList,
  getFacultyStatusConfirmed,
  getFacultyStatusDeleted,
  setOffset,
  setPage,
  setPerPage,
} from "../store/staff";
import useAuthStore from "./auth";

function useStaff() {
  const dispatch = useDispatch();

  const staffData = useSelector((state) => state.staff.data);
  const loading = useSelector((state) => state.staff.loading);
  const{institutionId}=useAuthStore();
  const staffPersonalInfo = useSelector(
    (state) => state.staff.staffPersonalInfo
  );
  const addNewEducation = useSelector(
    (state) => state.staff.educationInformation
  );
  const addNewEmployment = useSelector(
    (state) => state.staff.employmentInformation
  );
  const addNewCertification = useSelector((state) => state.staff.certification);
  const addNewAchievement = useSelector((state) => state.staff.achievement);
  const addNewInterest = useSelector((state) => state.staff.interest);
  const profileCompleteness = useSelector(
    (state) => state.staff?.profileCompleteness
  );
  const activeProfileImage = useSelector(
    (state) => state.staff.activeProfileImage
  );
  const facultyData = useSelector((state) => state.staff.facultyData);
  const facultyAttendance = useSelector(
    (state) => state.staff.facultyAttendance
  );
  const page = useSelector((state) => state.staff?.page);
  const perPage = useSelector((state) => state.staff?.perPage);
  const offset = useSelector((state) => state.staff?.offset);
 

  const setOffsetAction = (params) => dispatch(setOffset(params));
  const setPerPageAction = (params) => dispatch(setPerPage(params));
  const setPageAction = (params) => dispatch(setPage(params));

  const activeStaff = useSelector((state) => state.staff.activeStaff);
  const addStaffPersonalInfo = (params) => dispatch(addStaffInfo(params));
  const addEducationAction = () => dispatch(addEducation());
  const removeEducationAction = (params) => dispatch(removeEducation(params));
  const addStaffEducationInfo = (params) =>
    dispatch(addStaffEducationInformation(params));
  const addStaffEmploymentInfo = (params) =>
    dispatch(addStaffEmploymentInformation(params));
  const addEmploymentAction = () => dispatch(addEmployment());
  const removeEmploymentAction = (params) => dispatch(removeEmployment(params));
  const addStaffCertificationInfo = (params) =>
    dispatch(addStaffCertificationInformation(params));
  const removeCertificationAction = (params) =>
    dispatch(removeCertification(params));
  const addCertificationAction = () => dispatch(addCertification());
  const addStaffAchievmentsInfo = (params) =>
    dispatch(addStaffAchievmentsInformation(params));
  const addAchievementsAction = () => dispatch(addAchievement());
  const removeAchivementsAction = (params) =>
    dispatch(removeAchivement(params));
  const addStaffInterestInfo = (params) =>
    dispatch(addStaffInterestInformation(params));
  const getStaffInfoAction = (params) => dispatch(getStaffInfo(params));
  const searchStaffService = (params) => dispatch(searchStaffAction(params));
  const setActiveStaffAction = (params) => dispatch(setActiveStaff(params));
  const updateStaffAction = (params) => dispatch(updateStaff(params));
  const deleteStaffAction = (params) => {
    dispatch(deleteFacultyInfo(params));

    searchStaffService({
      data: {
        idDepartment: "",
        regNumber: "",
        sortBy: "",
        orderBy: "asc",
        limit: 100,
        offset: 0,
        institutionId
      },
      signal: new AbortController().signal,
    });
  };
  const deleteEduAction = (params) => dispatch(deleteFacultyEducation(params));
  const deleteEmployAction = (params) =>
    dispatch(deleteFacultyEmployment(params));
  const deleteCertifyAction = (params) =>
    dispatch(deleteFacultyCertification(params));
  const deleteAchiveAction = (params) =>
    dispatch(deleteFacultyAchievements(params));
  const uploadProfilePicAction = (params) => dispatch(uploadProfilePic(params));
  const facultySearchAction = (params) => dispatch(facultySearch(params));
  const getFacultyStatusConfirmedAction = (params) =>
    dispatch(getFacultyStatusConfirmed(params));
  const getFacultyStatusDeletedAction = (params) =>
    dispatch(getFacultyStatusDeleted(params));
  const setStaffProfileCompletenessAction = (params) =>
    dispatch(setStaffProfileCompleteness(params));
  const getStaffAttendanceAction = (params) =>
    dispatch(getStaffAttendance(params));
  const updateEductionInfoItemDataAction = (params) =>
    dispatch(updateEductionInfoItemData(params));
  const updateEmploymentInfoItemDataAction = (params) =>
    dispatch(updateEmploymentInfoItemData(params));
  const updateCertificationInfoItemDataAction = (params) =>
    dispatch(updateCertificationInfoItemData(params));
  const updateAchivementsInfoItemDataAction = (params) =>
    dispatch(updateAchivementsInfoItemData(params));
  const resetProfileCompletenessAction = (params) =>
    dispatch(resetProfileCompleteness(params));
  const resetPersonalInfoAction = (params) =>
    dispatch(resetPersonalInfo(params));
  const resetStaffAttendanceAction = (params) =>
    dispatch(resetStaffAttendanceList(params));
  const resetStaffPersonalInfoAction = (params) => {
    dispatch(resetStaffPersonalInfo(params));
  };
  return {
    //actions//
    addStaffPersonalInfo,
    addStaffEducationInfo,
    addStaffEmploymentInfo,
    addStaffCertificationInfo,
    addStaffAchievmentsInfo,
    addStaffInterestInfo,
    uploadProfilePicAction,
    addEducationAction,
    removeEducationAction,
    addEmploymentAction,
    removeEmploymentAction,
    addCertificationAction,
    removeCertificationAction,
    addAchievementsAction,
    removeAchivementsAction,
    getStaffInfoAction,
    searchStaffService,
    setActiveStaffAction,
    updateStaffAction,
    deleteStaffAction,
    deleteEduAction,
    deleteEmployAction,
    deleteCertifyAction,
    deleteAchiveAction,
    facultySearchAction,
    getFacultyStatusConfirmedAction,
    getFacultyStatusDeletedAction,
    setStaffProfileCompletenessAction,
    getStaffAttendanceAction,
    updateEductionInfoItemDataAction,
    updateEmploymentInfoItemDataAction,
    updateCertificationInfoItemDataAction,
    updateAchivementsInfoItemDataAction,
    resetProfileCompletenessAction,
    resetPersonalInfoAction,
    resetStaffPersonalInfoAction,
    resetStaffAttendanceAction,
    
    setOffsetAction,
    setPerPageAction,
    setPageAction,

    //States//
    page,
    perPage,
    offset,

    staffData,
    activeStaff,
    loading,
    addStaffInfo,
    addStaffEducationInformation,
    addStaffEmploymentInformation,
    addStaffCertificationInformation,
    addStaffAchievmentsInformation,
    addStaffInterestInformation,
    staffPersonalInfo,
    addNewEducation,
    addNewEmployment,
    addNewCertification,
    addNewAchievement,
    addNewInterest,
    facultyData,
    profileCompleteness,
    getStaffAttendance,
    facultyAttendance,
    activeProfileImage,
  };
}

export default useStaff;
